import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

function authHeaders() {
  const token = null;
  return token
    ? {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
}

export async function getClientAnalyticsOverview(params) {
  const res = await axios.get(`${API}/reports/client-analytics/overview`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientNewReturning(params) {
  const res = await axios.get(`${API}/reports/client-analytics/new-vs-returning`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientLtvBands(params) {
  const res = await axios.get(`${API}/reports/client-analytics/ltv-bands`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientRfm(params) {
  const res = await axios.get(`${API}/reports/client-analytics/rfm`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientAtRiskList(params) {
  const res = await axios.get(`${API}/reports/client-analytics/at-risk`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientRebookingRate(params) {
  const res = await axios.get(`${API}/reports/client-analytics/rebooking-rate`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientAnalyticsTopClients(payload) {
  const res = await axios.post(
    `${API}/reports/client-analytics/top-clients`,
    payload,
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}
